export function stickyTestimonialsSlider() {
    let $sliders = $(".sticky-testimonials-list .slider");

    let sliderOptions = {
        infinite: false,
        arrows: false,
        slidesToShow: 1,
        mobileFirst: true,
        dots: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1023,
                settings: "unslick"
            }
        ]
    };
    let sliderOptionsHorizont = {
        infinite: false,
        arrows: false,
        slidesToShow: 1,
        mobileFirst: true,
        dots: false,
        adaptiveHeight: false,
        variableWidth: true
    };

    function sliderInit() {
        $sliders.each((index, slide) => {
            let isHorizont = $(slide).closest(".sticky-testimonials-holder").hasClass("horizont-view");
            $(slide).slick(isHorizont ? sliderOptionsHorizont : sliderOptions);
        });
    }

    sliderInit();

    $(window).on("load resize", function () {
        $sliders.each((index, slide) => {
            let isHorizont = $(slide).closest(".sticky-testimonials-holder").hasClass("horizont-view"); 
            if (window.innerWidth < 1023 && !$(slide).hasClass("slick-initialized") && !isHorizont) {
                sliderInit();
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyTestimonialsSlider.js